import React from 'react';
const Feedback = () => <div className="p-8"><h1 className="text-2xl font-bold">Feedback Page</h1></div>;
export default Feedback; 